import { models } from '../../../../utils/cms-client';
import { IFormContext } from '../../../../contexts/form-context';
import { FullScreenLoadingIndicator } from '../../../base/full-screen-loading-indicator';
import { Feedback } from '../../../feedback';
import { generateSubmittedComponent, SubmissionObject } from '../generators';

export interface FormSubmissionProps {
  submitting: boolean;
  form: models.Form | undefined;
  labelMarkdown: string;
  formContext: IFormContext;
  setFormContext: Function;
}

const FormSubmission = ({
  submitting,
  form,
  labelMarkdown,
  formContext,
  setFormContext,
}: FormSubmissionProps) => {
  if (submitting) {
    return <FullScreenLoadingIndicator displayText={'Please wait...' as any} />;
  }

  const submission: SubmissionObject = generateSubmittedComponent({
    form,
    labelMarkdown,
    formContext,
  });

  if (submission.noNextSteps && !formContext.noApplicableNextSteps) {
    setFormContext({ ...formContext, noApplicableNextSteps: true });
  }

  let surveyFlag = false;
  if (
    form?.system.codename === 'vb_hospital' ||
    form?.system.codename === 'vb_accident' ||
    form?.system.codename === 'vb_critical_illness'
  ) {
    surveyFlag = true;
  }

  return (
    <>
      {surveyFlag && <Feedback timer={2000} />}
      {submission.markdown}
    </>
  );
};

export default FormSubmission;
